import React, { useEffect, useState, useMemo } from "react";
import { observer } from "mobx-react";
import { Tooltip } from "@mui/material";
import { Selector } from "../Select";
import emissionViewStore from "../../../Store/marco/emissionViewStore";
import styles from "../../modals/styles/EmissionActivityModal.module.css";
import { shouldShow } from "./utils/shouldShow";
import { flattenEAFormData } from "./utils/toRequestBody";
import { useTranslation } from "react-i18next";
import { EFDec } from "../EFDec";
import { emissionActivityModalAPI } from "../../API/emissionActivityAPI";
import { EFUnitValidation } from "./utils/EFUnitValidation";
import { useEFSelectOptions } from "./hooks/useEFSelectOptions";

export const EFFormComponent = observer(
  ({ EFSchema, formDataKey, handleSetFormData, target }) => {
    const API = emissionActivityModalAPI;
    const store = emissionViewStore;
    const formData = store[formDataKey];
    const { t } = useTranslation("ActivityMain");
    const cat = EFSchema?.catName;
    const category = EFSchema?.cat;

    const { optionsMap } = useEFSelectOptions({
      EFSchema,
      formData,
      showAddCustomEFModal: store.showAddCustomEFModal,
      cat,
      category,
      EAFormData: store.EAFormData,
    });

    const [EFOthersMapping, setEFOthersMapping] = useState([]);

    const flatFormData = useMemo(() => flattenEAFormData(formData), [formData]);
    ////////監控是不是到了最後一層
    useEffect(() => {
      //////// 4_3 LandEAFormData
      const landData = flattenEAFormData(store.landEAFormData);

      const data = flattenEAFormData(formData);

      ////////驗證EF單位是否跟數據輸入一致
      EFUnitValidation(data, landData, target, cat);
    }, [
      flatFormData.landEFTypeId,
      flatFormData.landEFId,
      flatFormData.emissionFactorTypeId,
      flatFormData.emissionFactorId,
    ]);

    const getEFOthersMappingData = async () => {
      const res = await API.getEFOthersNoteMap(EFSchema.cat);
      res.length > 0 ? setEFOthersMapping(res) : setEFOthersMapping([]);
    };

    useEffect(() => {
      getEFOthersMappingData();
    }, []);

    useEffect(() => {
      if (!flatFormData) return;

      const efId = flatFormData.emissionFactorId;
      const note = flatFormData.otherEFNote;

      // 若 EF 不在 mapping 裡 → 強制清空 remark
      if (!EFOthersMapping.includes(efId)) {
        if (note !== "") {
          // ⭐ 只有當目前 note 不是空，才更新（避免 infinite loop）
          handleSetFormData(EFSchema, 20, "otherEFNote", "", null, target);
        }
        return;
      }
    }, [flatFormData.emissionFactorId]);

    if (!EFSchema) return null;

    ////////Label FC
    function FieldLabel({ field, t, onAddCustom }) {
      return (
        <label>
          {field?.required && <span style={{ color: "red" }}>* </span>}
          {t(field?.label)}
          {field?.addBtn && (
            <Tooltip
              title={t("Add Custom Emission Factor")}
              arrow
              placement="top"
              slotProps={{
                tooltip: {
                  sx: {
                    fontSize: "14px",
                    padding: "8px 12px",
                  },
                },
              }}
            >
              <span className={styles.addIcon} onClick={onAddCustom}>
                +
              </span>
            </Tooltip>
          )}
        </label>
      );
    }

    return (
      <>
        {EFSchema?.fields
          .filter((f) =>
            shouldShow(f, formData, store[f?.specialDataShouldIf?.formData]),
          )
          .map((field) => {
            const shouldShowEFWarning =
              field.key === "emissionFactorId" &&
              (store.EFCheckId || store.landEFCheckId);

            const value =
              store.getEFValue(field.level, field.key, target) ?? "";

            return field.type === "title" ? (
              <div key={field.key} className={styles.specialTitle}>
                {t(field?.title)}
              </div>
            ) : field.type === "select" || field.type === "input" ? (
              <div key={field.key} className={styles.inputWrap}>
                <FieldLabel
                  field={field}
                  t={t}
                  onAddCustom={store._handleSwitchShowAddCustomEFModal}
                />

                {field.type === "select" ? (
                  <>
                    <Selector
                      field={field.key}
                      value={value}
                      options={optionsMap?.[field.key] || []}
                      placeholder=""
                      onChange={(_, v, opt) =>
                        handleSetFormData(
                          EFSchema,
                          field.level,
                          field.key,
                          v,
                          opt,
                          target,
                        )
                      }
                      autoFillNum={field?.autoFillNum}
                      translation={"EFMain"}
                    />
                    {shouldShowEFWarning ? (
                      <p
                        className={styles.EFWarningWords}
                        style={{ color: "red" }}
                      >
                        {/**EF 與數據設定衝突提醒 */}
                        {t(
                          "The emission factor and the data input unit are inconsistent.",
                        )}
                      </p>
                    ) : null}
                  </>
                ) : field.type === "input" ? (
                  <input
                    value={value}
                    placeholder={field.placeholder || null}
                    onChange={(e) =>
                      handleSetFormData(
                        EFSchema,
                        field.level,
                        field.key,
                        e.target.value,
                        null,
                        target,
                      )
                    }
                    className={styles.input}
                  />
                ) : null}
              </div>
            ) : null;
          })}
        {/**reMark */}
        {EFOthersMapping.includes(flatFormData?.emissionFactorId) ? (
          <div key={"remark"} className={styles.inputWrap}>
            <label>{t("remark")}</label>
            <input
              value={flatFormData?.otherEFNote}
              placeholder={null}
              onChange={(e) =>
                handleSetFormData(
                  EFSchema,
                  20,
                  "otherEFNote",
                  e.target.value,
                  null,
                  target,
                )
              }
              className={styles.input}
            />
          </div>
        ) : null}
        <>
          {/**排放係數詳細資料component */}
          <EFDec EFFormData={formData} target={target} />
        </>
      </>
    );
  },
);
